function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Videos",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Large",
  transform: "translate(-788.000000, -2765.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Footer",
  transform: "translate(0.000000, 2559.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-icons",
  transform: "translate(625.000000, 195.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rss",
  transform: "translate(150.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Social-/-Rss",
  transform: "translate(13.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8635,15.913 C12.8635,12.4955 11.532,9.284 9.1135,6.8715 C6.6955,4.4585 3.4775,3.13 0.052,3.13 L0.052,0 C4.315,0 8.321,1.654 11.332,4.658 C14.342,7.6625 16,11.659 16,15.913 L12.8635,15.913 Z M7.523,15.913 C7.523,11.7845 4.157,8.4255 0.02,8.4255 L0.02,5.2965 C5.887,5.2965 10.66,10.059 10.66,15.913 L7.523,15.913 Z M2.247,16 C1.006,16 0,14.9965 0,13.758 C0,12.5205 1.006,11.5165 2.247,11.5165 C3.4875,11.5165 4.4935,12.5205 4.4935,13.758 C4.4935,14.9965 3.4875,16 2.247,16 L2.247,16 Z",
  id: "rss"
})))))));

function SvgRss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Social / Rss") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/Rss.a8e0f816.svg";
export { ForwardRef as ReactComponent };